function updateTierBar(cart) {
  const bar = document.querySelector('.en-tier-bar');
  if (!bar) return;

  const tier1 = parseInt(bar.dataset.tier1, 10);
  const tier2 = parseInt(bar.dataset.tier2, 10);

  const shipTotal = cart.total_price;           // post-discount -> free shipping
  const bulkTotal = cart.original_total_price;  // pre-discount  -> bulk discount

  const hasShip = shipTotal >= tier1;
  const hasBulk = bulkTotal >= tier2;

  const fill = bar.querySelector('.en-tier-fill');
  const msg = bar.querySelector('.en-tier-msg');
  const dot1 = bar.querySelector('.en-marker1 .en-tier-dot');
  const dot2 = bar.querySelector('.en-marker2 .en-tier-dot');
  const reward1 = bar.querySelector('.en-reward[data-tier="1"]');
  const reward2 = bar.querySelector('.en-reward[data-tier="2"]');

  const marker1Pct = (tier1 / tier2) * 100;
let pct;
if (hasShip) {
  const seg = Math.max(bulkTotal - tier1, 0);
  pct = marker1Pct + (seg / (tier2 - tier1)) * (100 - marker1Pct);
} else {
  pct = (shipTotal / tier1) * marker1Pct;
}
pct = Math.min(Math.max(pct, 0), 100);
  fill.style.width = pct + '%';
  fill.classList.toggle('en-tier2-active', hasBulk);
  dot1.classList.toggle('is-reached', hasShip);
  dot2.classList.toggle('is-reached', hasBulk);
  dot2.classList.toggle('tier2', hasBulk);
  reward1.classList.toggle('is-reached', hasShip);
  reward2.classList.toggle('is-reached', hasBulk);
  reward1.querySelector('span').textContent = hasShip ? 'Free shipping ✓' : 'Free shipping';
  reward2.querySelector('span').textContent = hasBulk ? 'Bulk Discount ✓' : 'Bulk Discount';

  const fmt = cents => 'R' + Math.ceil(cents / 100).toLocaleString('en-ZA');

  if (hasBulk && hasShip) {
    msg.className = 'en-tier-msg is-unlocked';
    msg.innerHTML = 'Free shipping and Bulk Buy Discount — applied.';
  } else if (hasBulk) {
    msg.className = 'en-tier-msg';
    msg.innerHTML = 'Bulk Buy Discount applied. Spend <strong>' + fmt(tier1 - shipTotal) + '</strong> more for <strong>free shipping</strong>';
  } else if (hasShip) {
    msg.className = 'en-tier-msg';
    msg.innerHTML = 'Spend <strong>' + fmt(tier2 - bulkTotal) + '</strong> more for <strong>Bulk Buy Discount</strong>';
  } else {
    msg.className = 'en-tier-msg';
    msg.innerHTML = 'Spend <strong>' + fmt(tier1 - shipTotal) + '</strong> more for <strong>free shipping</strong>';
  }

  fitMsgText(msg);
}

const _fetch = window.fetch;
window.fetch = function(...args) {
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  const isCartChange = /\/cart\/(add|change|update|clear)\.js/.test(url);

  const result = _fetch.apply(this, args);

  if (isCartChange) {
    result.then(res => res.clone().json()).then(data => {
      if (/\/cart\/add\.js/.test(url)) {
        // add.js only returns the added line item, so re-fetch the cart
        fetch('/cart.js').then(r => r.json()).then(updateTierBar);
      } else if (data.total_price !== undefined) {
        updateTierBar(data);
      }
    });
  }

  return result;
};

// Initial render on page load
fetch('/cart.js').then(r => r.json()).then(updateTierBar);